import {Injectable} from '@angular/core';
import 'rxjs/add/operator/do';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {LoadingService} from '../services/loading.service';
import {CommonService} from '../services/common.service';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService,
              private loadingService: LoadingService,
              private commonService: CommonService,
              private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {
          // Response handling is performed by subscribers.
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.authService.clearAccessToken();
              if (err.url.indexOf('/auth/login') < 0) {
                this.router.navigate(['/auth/login']);
              }
            }
            if (err.status === 403) {
              this.router.navigate(['/error/vuot-quyen']);
            }
            if (err.status === 404) {
              this.router.navigate(['/error/khong-tim-thay']);
            }
            if (err.status === 500) {
              this.router.navigate(['/error/loi-he-thong']);
            }
            if (err.status === 0) {
              this.router.navigate(['/error/he-thong-nang-cap']);
            }
          }
        },
      ),
      finalize(() => this.loadingService.hide()),
    );
  }

}
